import React, { useState } from "react";
import { uploadImageToFirebase, addArticleToFirestore } from "./articleService";

function ArticleForm() {
  const [article, setArticle] = useState({
    title: "",
    image: null,
    imagePreview: null,
    authorName: "",
    authorPosition: "",
    authorAffiliation: "",
    references: [""],
    body: [""],
    category: "",
  });
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleArticleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    setError("");

    try {
      let imageUrl = null;
      if (article.image) {
        imageUrl = await uploadImageToFirebase(article.image);
      }

      const articleData = {
        ...article,
        image: imageUrl,
        references: JSON.stringify(article.references),
        body: JSON.stringify(article.body),
        createdAt: new Date().toISOString(),
      };

      const docId = await addArticleToFirestore(articleData);
      alert(`Article posted successfully! ID: ${docId}`);

      setArticle({
        title: "",
        image: null,
        imagePreview: null,
        authorName: "",
        authorPosition: "",
        authorAffiliation: "",
        references: [""],
        body: [""],
        category: "",
      });
    } catch (error) {
      console.error("Error posting article:", error);
      setError("Failed to post the article. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleFieldChange = (field, index, value) => {
    const updatedField = [...article[field]];
    updatedField[index] = value;
    setArticle({ ...article, [field]: updatedField });
  };

  const addField = (field) => {
    setArticle({ ...article, [field]: [...article[field], ""] });
  };

  const removeField = (field, index) => {
    const updatedField = article[field].filter((_, i) => i !== index);
    setArticle({ ...article, [field]: updatedField });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setArticle({ ...article, image: file, imagePreview: URL.createObjectURL(file) });
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <h3 className="text-2xl font-bold mb-6">Post an Article</h3>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleArticleSubmit} className="space-y-4">
        <input type="text" placeholder="Article Title" value={article.title} onChange={(e) => setArticle({ ...article, title: e.target.value })} required className="w-full p-3 border rounded-md" />
        
        <div>
          <label className="block mb-2 font-medium">Upload Image</label>
          <input type="file" accept="image/*" onChange={handleImageChange} className="block w-full text-sm text-gray-500 border rounded-md" />
          {article.imagePreview && <img src={article.imagePreview} alt="Preview" className="mt-2 w-40 h-40 object-cover" />}
        </div>
        
        <input type="text" placeholder="Author Name" value={article.authorName} onChange={(e) => setArticle({ ...article, authorName: e.target.value })} required className="w-full p-3 border rounded-md" />
        <input type="text" placeholder="Author Position" value={article.authorPosition} onChange={(e) => setArticle({ ...article, authorPosition: e.target.value })} required className="w-full p-3 border rounded-md" />
        <input type="text" placeholder="Author Affiliation" value={article.authorAffiliation} onChange={(e) => setArticle({ ...article, authorAffiliation: e.target.value })} required className="w-full p-3 border rounded-md" />

        <div className="space-y-2">
          <h4 className="font-medium">References</h4>
          {article.references.map((reference, index) => (
            <div key={index} className="flex items-center space-x-2">
              <input type="text" placeholder={`Reference ${index + 1}`} value={reference} onChange={(e) => handleFieldChange("references", index, e.target.value)} required className="flex-1 p-3 border rounded-md" />
              <button type="button" onClick={() => removeField("references", index)} className="p-1 bg-red-500 text-white rounded-md">×</button>
            </div>
          ))}
          <button type="button" onClick={() => addField("references")} className="p-2 bg-green-500 text-white rounded-md">Add Reference</button>
        </div>

        <div className="space-y-2">
          <h4 className="font-medium">Body</h4>
          {article.body.map((paragraph, index) => (
            <div key={index} className="flex items-center space-x-2">
              <textarea placeholder={`Paragraph ${index + 1}`} value={paragraph} onChange={(e) => handleFieldChange("body", index, e.target.value)} required className="flex-1 p-3 border rounded-md" />
              <button type="button" onClick={() => removeField("body", index)} className="p-1 bg-red-500 text-white rounded-md">×</button>
            </div>
          ))}
          <button type="button" onClick={() => addField("body")} className="p-2 bg-green-500 text-white rounded-md">Add Paragraph</button>
        </div>

        <select value={article.category} onChange={(e) => setArticle({ ...article, category: e.target.value })} required className="w-full p-3 border rounded-md">
          <option value="" disabled>Select Category</option>
          <option value="Research">Research</option>
          <option value="Innovation">Innovation</option>
          <option value="Field Work">Field Work</option>
          <option value="Publication">Publication</option>
          <option value="Other">Other</option>
        </select>

        <button type="submit" className="w-full px-4 py-2 text-white bg-indigo-600 rounded-md hover:bg-indigo-700 flex justify-center items-center" disabled={uploading}>
          {uploading ? <span className="loader"></span> : "Submit Article"}
        </button>
      </form>
    </div>
  );
}

export default ArticleForm;
